import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import ApplyImg from '../images/Apply Now_1.jpg'
import ExistCustomer from '../images/Existing_Customers.jpg'
import CanMoney from '../images/payday-payday-loans-ca-4.jpg'

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:''};				
	}

	componentDidMount() {				
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	render() {		
		return(
			<div>
				<CommonHeader titles="Bad Credit"/>				
				<h1 className="headings" style={{textAlign:"center",color:"green"}}><small>{this.state.CompName}--Payday Loan Provider for Canadians</small></h1>				
				<div id="contentwrapper" >
					<div id="contentcolumn">
						<Link className="applybutton" to = "/Apply"><img border="0" src={ApplyImg} alt="Payday loans application"/></Link>
						<Link className="applybutton" to = "/Member"><img border="0" src={ExistCustomer} alt="Payday loans Returning Customers"/></Link>
					</div>
				</div>
				<div id="rightcolumn">
					<div className="innertext">
						<b style={{color:"green"}}>No Fax</b><br/>
						<b style={{color:"green"}}>Fast and Easy</b><br/>
						<b style={{color:"green"}}>No hidden cost</b><br/>
						<b style={{color:"green"}}>No Credit Check</b><br/>
						<b style={{color:"green"}}>Up to $600 until next pay day</b><br/>
						<b style={{color:"green"}}>Cash advance deposited directly to your account</b><br/>
					</div>
				</div>
				<div id="leftcolumn" title="Your payday loans"><img src={CanMoney} alt="Your Payday loans and cash advance"/></div>
				<div id="bottom"><br/>
					<h1 style={{color:"blue"}}>Bad Credit Loans</h1>
					<h4 style={{color:"grey"}}>When you need money to cover an unexpected expenses or abrupt and urgent needs, however you can not get loans from banks due to 
					the bad credits. In such situations, bad credit laons are the best way to generate finance for your financial crises with ease. For whatever reasons, 
					at {this.state.CompName} we take care of your unexpected challenges without the stress of credit checks and we realize that we can meet your financial 
					emergency without begging moeny from relatives or friends. This is what we do and what we provide. No credit check required, no fax needed, no waiting in 
					line, convenient and confidential. Just fill out the online application at your home in your privacy. No friends or acuqintances in case you want to keep 
					your financial situation private<br/><br/>

					Just take minutes to complete our online payday loan application. Your payday loans will be deposited into your banking account quickly. It's very simple and 
					it's very fast and the best part it's super easy to apply<br/><br/>
					If you are 18 years of age (minimum applicant age for our payday loans) or above and locating in Canada, you are welcome to use our friendly services. 
					No hassle, no credit check required, no misleading, no hidden cost. We are always willing to be a support. If you are ready to experience the simplest payday 
					loan online then all you need to do is <Link style={{color:"#0040ff"}} to = "/Apply">click here</Link> to start your application</h4>
					<h1 style={{color:"#0040ff"}}><Link style={{color:"#0040ff"}} to = "/Apply">Apply Now!</Link> Get approved today!</h1>
				</div>								
			</div>
		)
	}
}

export default HomtContents